import React, { useLayoutEffect, useState } from "react";
import ReactDOM from "react-dom";

interface PortalProps {
  children: React.ReactNode;
}

/**
 * Portal
 */
const Portal: React.FC<PortalProps> = ({ children }) => {
  const [isRendered, setIsRendered] = useState<boolean>(false);

  useLayoutEffect(() => {
    setIsRendered(true);
  }, []);

  if (!isRendered) {
    return null;
  }

  return ReactDOM.createPortal(
    children,
    document.getElementById("root") as HTMLDivElement,
  );
};

export default Portal;
